const QuestionTypeEnum = {
  ShortText: 1,
  LongText: 2,
  SingleChoice: 3,
  MultipleChoice: 4,
  Dropdown: 5,
  Scale: 6,
  Date: 7,
  Number: 8,
  Email: 9
};

export default QuestionTypeEnum;
